<div class="lp-canvas-renderer-arrows" style="position: absolute; inset: 1em; pointer-events: none">
  @let distanceFromTop = origin()[1] * screenSize()[1];
  @let distanceFromRight = (size()[0] - 1 - origin()[0]) * screenSize()[0];
  @let distanceFromBottom = (size()[1] - 1 - origin()[1]) * screenSize()[1];
  @let distanceFromLeft = origin()[0] * screenSize()[0];
  @let arrowThreshold = 64;
  <app-canvas-arrow [doShow]="distanceFromTop > arrowThreshold" anchor="top" />
  <app-canvas-arrow [doShow]="distanceFromRight > arrowThreshold" anchor="right" />
  <app-canvas-arrow [doShow]="distanceFromBottom > arrowThreshold" anchor="bottom" />
  <app-canvas-arrow [doShow]="distanceFromLeft > arrowThreshold" anchor="left" />
</div>
